import type { GridProps } from '@chakra-ui/react'
import { Flex, forwardRef, Grid } from '@chakra-ui/react'

import { Container } from '../ui/Container'

export type StepsContainerProps = GridProps

export const StepsContainer = forwardRef(
  ({ children, sx, ...rest }: StepsContainerProps, ref) => {
    return (
      <Grid ref={ref} sx={{ bg: 'steps-container-bg', ...sx }} {...rest}>
        <Container>
          <Grid
            sx={{
              gridTemplateColumns: { md: '250px 2rem 1fr' },
              alignItems: 'center',
            }}
          >
            <Grid></Grid>
            <Grid></Grid>

            <Flex sx={{ w: '100%', justifyContent: 'stretch' }}>
              {children}
            </Flex>
          </Grid>
        </Container>
      </Grid>
    )
  },
)
